"use client";

import { useEffect } from "react";
import { useTheme } from "./theme";

export default function ThemedLayoutWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const { theme } = useTheme();

  useEffect(() => {
        // Apply theme class
        document.documentElement.classList.remove("dark", "light");
        document.documentElement.classList.add(theme);

        // Update meta tags
        const updateMetaTag = (name: string, content: string) => {
        let tag = document.querySelector(`meta[name="${name}"]`);
        if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute("name", name);
            document.head.appendChild(tag);
        }
        tag.setAttribute("content", content);
        };

        updateMetaTag("theme-color", theme === "dark" ? "#000000" : "#ffffff");
        updateMetaTag("color-scheme", theme);
    }, [theme]);

    // ⚠️ NEVER gate this component on `mounted` / client-only state.
    // Returning `null` during SSR means React never awaits `{children}` while
    // rendering the shell, so Next.js flushes the first byte (committing
    // HTTP 200) before [...slug]/page.tsx gets to call notFound()/redirect().
    // That is what made every 404 respond with 200.
    return <>{children}</>;
}
